import React from 'react'
import { useTranslation } from 'react-i18next'

interface RoleCellProps {
  role: string
  sub_role: string
}

export const RoleCell = ({ role, sub_role }: RoleCellProps) => {
  const { t } = useTranslation()

  return (
    <span>{t(role === 'owner' ? 'pages.team.roles.' + role : 'pages.team.roles.' + sub_role)}</span>
  )
}
